module.exports = __webpack_public_path__ + "static/media/MaskGroup2@2x.31a1dd23.jpg";